import React, {useEffect, useRef, useState} from 'react';
import "../Menu/Menu.scss";
import SimpleLineIcon from "react-simple-line-icons";
import Swiper from 'react-id-swiper';
import 'swiper/swiper-bundle.css';
import {LazyBackground, Nav} from "../../Components";
import {CatsData, ProductData, ProductDetailData, RootData, SlugData, StoreData} from "../Menu/MenuServices";
import {useDispatchMall, useSpeech} from "../../hooks";
import '../../../node_modules/rc-tabs/assets/index.css';
import {useHistory, useLocation, useParams} from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import Rodal from "rodal";
import "./Land.scss";
import {fixNumbers, LoginRequest, MessageHandler, Validation} from "../../Services";
import toaster from "toasted-notes";
import {Message} from "toasted-notes/commonjs/Message";
import {CheckinData} from "../Scan/ScanServices";


const styles = {
    slide: {
        padding: 15,
        minHeight: 100,
        color: '#fff',
    },
    slide1: {
        backgroundColor: '#FEA900',
    },
    slide2: {
        backgroundColor: '#B3DC4A',
    },
    slide3: {
        backgroundColor: '#6AC0FF',
    },
};


function SkeletonProduct({show}) {
    return (
        <div className="product-list">
            {show && [1, 2, 3, 4].map(item => {
                return (
                    <div className="menu-product-card">
                        <div className="menu-product-card-img">
                            <Skeleton width={'100%'} height={'100%'}/>
                        </div>
                        <span className="title"><Skeleton width={100}/></span>
                        <span className="price"><Skeleton width={30}/></span>
                    </div>
                )
            })}
        </div>
    )

}


function isEven(value) {
    if (value % 2 == 0)
        return true;
    else
        return false;
}

function Land() {

    const speech = useSpeech();
    const CatRef = useRef(null);
    const MyRef = useRef(null);
    const location = useLocation();
    const { slug } = useParams();
    //hooks
    const history = useHistory()
    const setMall = useDispatchMall();

    const [mobile,setMobile] = useState("");
    const [loginState,setLoginState] = useState(false);
    const [btnState,setBtnState] = useState(true);


    function callback(e) {
        setCurrentCat(e)
    }

    const CatClick = (cat) => {
        // console.log(cat)
        setCurrentPro(cat)
    }


    const paramsRoot = {
        slidesPerView: 3,
        spaceBetween: 0,
        rtl: true,
        // rebuildOnUpdate : true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        }
    }

    const imageParams = {
        slidesPerView: 'auto',
        spaceBetween: 0,
        rtl:true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        }
    }


    const params = {
        slidesPerView: 4,
        spaceBetween: 0,
        rtl: true,
        // centeredSlides: true,
        // rebuildOnUpdate : true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        }
    }

    const [preload, setPreload] = useState(true);
    const [failed, setFailed] = useState(false);
    const [search, setSearch] = useState("");
    const [allProducts, setAllProducts] = useState([]);

    const [originalList, setOriginalList] = useState([])
    const [list, setList] = useState([])
    const [products, setProducts] = useState([])


    const [cats, setCats] = useState([])
    const [allCats, setAllCats] = useState([])
    const [roots, setRoots] = useState([])
    const [all, setAll] = useState([])

    const [currentRootId, setcurrentRootId] = useState("");
    const [currentC, setCurrentC] = useState("");
    const [sklMode, setSklMode] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [productItem, setProductItem] = useState({});
    const [merchant, set_merchant] = useState(null);
    const [isLogin, set_isLogin] = useState(false);



    const setCurrentCat = (rootId) => {
        let cats = allCats.filter(cat => cat.parent.uid === rootId);
        cats.reverse();
        setCats(cats)
        setcurrentRootId(rootId)
        setTimeout(() => {
            if (CatRef.current) {
                CatRef.current.swiper.update();
            }
        }, 0)


        setCurrentC({uid: "0"})

        // let a1 = allCats.filter(cat=>cat.parent.uid===rootId).map(item=>item.uid);
        // let a2 = allProducts.filter(product=>{return a1.includes(product.parentUid)})
        let candidate_cats = allCats.filter(cat => cat.parent.uid === rootId);
        candidate_cats.forEach(cat => {
            let candidate_products = allProducts.filter(product => {
                return product.parentUid === cat.uid
            })
            cat['products'] = candidate_products;
        })

        setProducts([])
        candidate_cats.reverse();
        setAll(candidate_cats);


    }

    const setCurrentPro = (cat) => {
        let prod = allProducts.filter(p => p.parentUid === cat.uid);
        setCurrentC(cat)
        setProducts(prod)
        setAll([]);
    }

    const getAllCat = () => {
        getAllCatSub();
        // setCurrentC({uid:'0'})
        // let a1 = allCats.filter(cat=>cat.parent.uid===currentRootId).map(item=>item.uid);
        // let a2 = allProducts.filter(product=>{return a1.includes(product.parentUid)})
        //setProducts(a2);
    }

    const getAllCatSub = () => {
        setCurrentC({uid: '0'})
        let candidate_cats = allCats.filter(cat => cat.parent.uid === currentRootId);
        candidate_cats.forEach(cat => {
            let candidate_products = allProducts.filter(product => {
                return product.parentUid === cat.uid
            })
            cat['products'] = candidate_products;
        })

        setProducts([])
        candidate_cats.reverse()
        setAll(candidate_cats);
    }

    const searchList = (word) => {
        if (word.length < 1) {
            getAllCatSub();
            // let a1 = allCats.filter(cat=>cat.parent.uid===currentRootId).map(item=>item.uid);
            // let a2 = allProducts.filter(product=>{return a1.includes(product.parentUid)})
            // setProducts(a2);
        }
        if (word.length > 2) {
            let result = []
            allProducts.forEach(item => {
                if (item.name.includes(word)) {
                    result.push(item)
                }
            });
            setProducts(result)
            setAll([]);
        }
    }


    useEffect(() => {
        window.scrollTo(0, 0);
        checkRoot()
        // console.log("slug : ",slug)
        if(slug){
            //get merchant with slug
            getSlug(slug.substring(1))
            //check user is login
            if(localStorage.getItem('token')){
                set_isLogin(true)
            }

        }
    }, [])


    const checkRoot = () => {
        // console.log("Item : ", location.state)
    }


    const getSlug = async (slug) => {
        const response = await SlugData(slug);
        // console.log(response)
        set_merchant(response.data)
        getRoot(response.data.uid);

    }

    const getRoot = async (merchantUID) => {
        setSklMode(true);
        // console.log("EVENT : ", merchantUID)
        const response_root = await RootData(merchantUID);
        // console.log("root: ", response_root.data);
        if (response_root.data.length > 0) {
            response_root.data.reverse()
            setRoots(response_root.data);
            let cRootId = response_root.data[0].uid
            setcurrentRootId(cRootId);
            getCats(response_root.data, cRootId, merchantUID);
        }
    }

    const getCats = async (roots, rootId, merchantUID) => {
        let promises = [];
        roots.forEach(root => {
            promises.push(CatsData(merchantUID, root.uid))
        })

        const Cats = await Promise.all(promises);

        let all_cats = [];
        Cats.forEach(cats => {
            cats.data.forEach(cat => {
                all_cats.push(cat);
            })
        })

        setAllCats(all_cats)
        let cats = all_cats.filter(cat => cat.parent.uid === rootId);
        cats.reverse();
        setCats(cats);
        getProducts(all_cats, cats[0], rootId, merchantUID)
        // if(cats.length>4){
        //     getProducts(all_cats,cats[5])
        //     CatRef.current.swiper.slideTo(5);
        // }else {
        //     getProducts(all_cats,cats[0])
        // }

    }


    const getProducts = async (cats, initCat, rootId, merchantUID) => {
        let promises = [];
        setCurrentC(initCat)
        // console.log("Tes ", cats)
        cats.forEach(cat => {
            promises.push(ProductData(merchantUID, cat.uid))
        })

        const Products = await Promise.all(promises);

        let all_products = [];
        Products.forEach((pro, i) => {
            pro.data.results.forEach((p) => {
                all_products.push({name: p.name, image: p.image, price: p.price, uid: p.uid, parentUid: cats[i].uid});
            })
        })


        // console.log(all_products);


        setAllProducts(all_products)

        setCurrentC({uid: "0"})

        let candidate_cats = cats.filter(cat => cat.parent.uid === rootId);
        candidate_cats.forEach(cat => {
            let candidate_products = all_products.filter(product => {
                return product.parentUid === cat.uid
            })
            cat['products'] = candidate_products;
        })

        setProducts([])
        candidate_cats.reverse();
        setAll(candidate_cats);


        setSklMode(false);
    }

    const productClick = async (item) =>{
        setProductItem(item)
        setShowModal(true)
        try{
            let merchant = {};
            if (location && location.state && location.state.event) {
                merchant = location.state.event.uid
            }
            if (location && location.state && location.state.item) {
                merchant = location.state.item.merchantId
            }
            const response = await ProductDetailData(merchant,item.uid)
            // console.log("Product : ",response.data)
            setProductItem(response.data)

        }catch (e) {
            // console.log(e)
        }
    }

    const Login_Request = async () => {
        // window.location.href = "tel:*556*12*sdfs4555%23"
        // return
        if(loginState){return }
        // pre request
        setLoginState(true);

        if (!Validation({type:"MOBILE",val:fixNumbers(mobile)})){
            MessageHandler({type:"VALIDATION",status:"MOBILE"})
            setLoginState(false);
            return ;
        }



        //request
        try{
            let response = await LoginRequest({phone:fixNumbers(mobile)})

            //post success request
            setLoginState(false);

            //set Mobile to Suggestion
            let suggestion_obj = [];
            let suggestion_storage = localStorage.getItem("mobileSuggestion");
            if(suggestion_storage){
                suggestion_obj = JSON.parse(suggestion_storage);
            }

            //Check Suggestion Exist
            let exist = suggestion_obj.find(item=>item.mobile===fixNumbers(mobile))
            if(!exist){
                suggestion_obj.push({mobile:fixNumbers(mobile)})
            }
            localStorage.setItem("mobileSuggestion",JSON.stringify(suggestion_obj))

            //clear

            history.push("/verify",{
                token:response.data.token,mobile:mobile,
                mall:merchant.mall
            })
            MessageHandler({type:"LOGIN",status:"SUCCESS"})
        }catch (e) {
            //post failed request
            setLoginState(false);
            MessageHandler({type:"LOGIN",status:"ERROR"})
        }
    }


    function Error(props) {

        return(
            <div className="error_message-container">
                <span className="text-message">{props.message}</span>
            </div>
        )
    }

    const loginError = () =>{
        toaster.notify(({ onClose }) => (<Error   message={"برای استفاده از این امکان باید وارد شوید"}/>),{duration: 2000});
    }

    const setMallFlow = async () =>{
        let malli = merchant.mall;
        await CheckinData("mc_"+malli.uid)
        localStorage.setItem('mallId',malli.uid);
        localStorage.setItem('mallLogo',malli.header_image);
        localStorage.setItem('mallWhite',malli.logo);
        localStorage.setItem('mallName',malli.name);
        localStorage.setItem('mall',JSON.stringify(malli));
        setMall(malli);
    }

    return (
        <div className="landing-container">
            <div className="a-pluse-subject">
                {/*<img src="/svg/cafe-shemroon.svg" alt=""/>*/}
                {merchant?<img src={merchant.thumbnail} alt=""/>:null}
                {merchant?<span> {merchant.name}</span>:null}
            </div>
            <div className="menu-container landing-back" style={{
                backgroundImage: `url(${merchant?merchant.cover:""})`}}>

                <Rodal  customStyles={{width:'90%', height: 'auto',
                    bottom: 'auto',
                    top: '20%'}} animation={"zoom"} visible={showModal} showCloseButton={false} onClose={() => setShowModal(false)}>
                    <div className="product-modal">
                        <img className="productItem-img" src={productItem.image} alt=""/>
                        <span className="productItem-name">{productItem.name}</span>
                        <span className="productItem-price">{productItem.price} ریال  </span>
                        <div className="productItem-desc">
                            <span>توضیحات</span>
                            {productItem && productItem.des?<p className={productItem.des.length>130?"product-item-scroll":""}>{productItem.des}</p>:null}
                        </div>
                    </div>
                </Rodal>

                {/* ------------- Main Image ----------------- */}

                {/*<div className="main-image">*/}
                {/*    <img src="https://s3.mobank.co/loyalty-media/merchant/merchant/images/large_pic_ZkckqG7_A8w4hDR.png" alt=""/>*/}

                {/*</div>*/}


                {/* ------------- Chart Section ----------------- */}
                <div className={!isLogin?"services-section":"services-section-login"} >
                    {/*<a href="tel:*556%23">Check balance</a>*/}
                    {!isLogin?<div className="get-mobile-section">
                        <p>برای بهره‌مندی از مزایای باشگاه مشتریان  شماره تلفن خود را وارد کنید.</p>
                        <div className="input-mobile">
                            <div className="input-login-btn" onClick={Login_Request}>
                                {loginState?<i className="fa fa-spinner fa-spin"></i>: <i className="fa fa-angle-left"></i>}
                                <span>ورود</span>
                            </div>
                            <input
                                value={mobile}
                                onChange={(e)=>{
                                    setMobile(e.target.value)
                                }}
                                type="text" name="" id="" placeholder="شماره تلفن"/>
                            <i className="fa fa-mobile badg-icon"></i>
                        </div>
                    </div>:null}
                    <div className="landing-title-row">
                        <span>سرویس های {merchant && merchant.name}</span>
                    </div>
                    <div className="service-list">
                        <Swiper ref={MyRef}    {...imageParams}>
                            <div className="service-item" onClick={async ()=>{
                                if(!isLogin){
                                    loginError()
                                }else {
                                    await setMallFlow();
                                    history.push("/")
                                }
                            }}>
                                <div className="service-icon">
                                    <img src="/svg/gift.svg" alt=""/>
                                </div>
                                <div className="service-info">
                                    <div className="service-info-title">
                                        پاداش خرید
                                    </div>
                                    <div className="service-info-desc">
                                        با هر خرید پاداش بگیر
                                    </div>
                                </div>
                            </div>

                            <div className="service-item">
                                <div className="service-icon">
                                    <img src="/svg/basket.svg" alt=""/>
                                </div>
                                <div className="service-info" onClick={async ()=>{
                                    if(!isLogin){
                                        loginError()
                                    }else {
                                        await setMallFlow();
                                        // history.push("/download/online")
                                        history.push(`/online-store/${merchant && merchant.uid}`)
                                    }
                                }}>
                                    <div className="service-info-title" >
                                        سفارش آنلاین
                                    </div>
                                    <div className="service-info-desc">
                                        خرید آنلاین محصولات
                                    </div>
                                </div>
                            </div>

                            <div className="service-item" onClick={async ()=>{
                                if(!isLogin){
                                    loginError()
                                }else {
                                    await setMallFlow();
                                    history.push("/")
                                }
                            }}>
                                <div className="service-icon">
                                    <img src="/svg/time.svg" alt=""/>
                                </div>
                                <div className="service-info">
                                    <div className="service-info-title">
                                        رویدادها
                                    </div>
                                    <div className="service-info-desc">
                                        باخبر شدن از رویدادها و جشنواره ها
                                    </div>
                                </div>
                            </div>
                        </Swiper>
                    </div>
                </div>
                <div className="merchant-desc">
                    <p>{merchant && merchant.description}</p>
                </div>
                {/*<div className="store-head">*/}
                {/*    <div className="root-menu">*/}
                {/*        <div className="c-tabs" >*/}
                {/*            <div className="landing-title-row">*/}
                {/*                <span>منوها</span>*/}
                {/*            </div>*/}
                {/*            {roots.length > 0 ? <Swiper ref={MyRef}    {...paramsRoot}>*/}
                {/*                    {roots.map(root => {*/}
                {/*                        return (*/}
                {/*                            <div className={currentRootId === root.uid ? "c-tabs-item active" : "c-tabs-item"}*/}
                {/*                                 onClick={() => {*/}
                {/*                                     setCurrentCat(root.uid)*/}
                {/*                                 }}>{root.name}</div>*/}
                {/*                        )*/}
                {/*                    })}*/}
                {/*                </Swiper> :*/}
                {/*                <>*/}
                {/*                    {sklMode ? <div className="Skeleton">*/}
                {/*                        <Skeleton width={100}/>*/}
                {/*                        <Skeleton width={100}/>*/}
                {/*                        <Skeleton width={100}/>*/}
                {/*                    </div> : null}*/}
                {/*                </>*/}
                {/*            }*/}
                {/*        </div>*/}
                {/*    </div>*/}


                {/*    <div className="c-tabs cats-swiper">*/}
                {/*        {cats.length > 0 ? <Swiper dir={"rtl"} ref={CatRef}   {...params} >*/}
                {/*                <div className="cats_menu" onClick={() => getAllCat()}>*/}
                {/*                    <img*/}
                {/*                        className={currentC.uid === '0' ? "active" : ""}*/}
                {/*                        src={"/other/merchant_logo.png"} alt=""/>*/}
                {/*                    {"همه"}*/}
                {/*                </div>*/}
                {/*                {cats.map(cat => {*/}
                {/*                    return (*/}
                {/*                        <div className="cats_menu" onClick={() => CatClick(cat)}>*/}
                {/*                            {cat.img ?*/}
                {/*                                <img src={cat.image} alt=""*/}
                {/*                                     className={currentC.uid === cat.uid ? "active" : ""}/> :*/}
                {/*                                <img src={cat.image} alt=""*/}
                {/*                                     className={currentC.uid === cat.uid ? "active" : ""}/>*/}
                {/*                            }*/}
                {/*                            {cat.name}*/}
                {/*                        </div>*/}
                {/*                    )*/}
                {/*                })}*/}
                {/*            </Swiper> :*/}
                {/*            <>*/}
                {/*                {sklMode ? <div className="Skeleton">*/}
                {/*                    <Skeleton circle={true} height={60} width={60}/>*/}
                {/*                    <Skeleton circle={true} height={60} width={60}/>*/}
                {/*                    <Skeleton circle={true} height={60} width={60}/>*/}
                {/*                    <Skeleton circle={true} height={60} width={60}/>*/}
                {/*                </div> : null}*/}
                {/*            </>*/}
                {/*        }*/}
                {/*    </div>*/}

                {/*    /!*{cats.length>0?*!/*/}
                {/*    /!*    <div className="menu-categories">*!/*/}
                {/*    /!*        /!*OnlineStoreSubCat List*!/*!/*/}
                {/*    /!*        <div className="store-categories-list">*!/*/}
                {/*    /!*            {cats.length>0?  <Swiper  ref={CatRef}  {...params} shouldSwiperUpdate>*!/*/}
                {/*    /!*                {cats.slice(0,5).map(cat=>{*!/*/}
                {/*    /!*                    return (*!/*/}
                {/*    /!*                        <div key={cat.uid}  className="menu-categories-item" onClick={()=>CatClick(cat)}>*!/*/}
                {/*    /!*                            <img src={"https://s3.mobank.co/loyalty-media/product/product_category/images/kebab.jpg"} alt="" style={{width:'100%'}}/>*!/*/}
                {/*    /!*                            <span>{cat.name}</span>*!/*/}
                {/*    /!*                        </div>*!/*/}
                {/*    /!*                    )*!/*/}
                {/*    /!*                })}*!/*/}
                {/*    /!*            </Swiper>:null}*!/*/}
                {/*    /!*        </div>*!/*/}
                {/*    /!*    </div>*!/*/}
                {/*    /!*    :null}*!/*/}


                {/*    {products.length > 0 ?*/}
                {/*        <div className="product-wrapper-one"  >*/}
                {/*            <div className="cat-title">*/}
                {/*                <h3>{currentC.name}</h3>*/}
                {/*            </div>*/}
                {/*            <div className={isEven(products.length) ? "product-list" : "product-list product-list-odd"}>*/}
                {/*                {products.map(item => {*/}
                {/*                    return (*/}
                {/*                        <div className="menu-product-card" onClick={()=>{*/}
                {/*                            productClick(item)*/}
                {/*                        }}>*/}
                {/*                            /!*<img src={item.image} alt=""/>*!/*/}
                {/*                            /!*<div className="menu-product-card-img" style={{backgroundImage: `url(${item.image})`}}>*!/*/}
                {/*                            /!*</div>*!/*/}
                {/*                            <LazyBackground src={item.image}/>*/}
                {/*                            <span className="title">{item.name}</span>*/}
                {/*                            <span className="price">{`${item.price} ریال `}</span>*/}
                {/*                        </div>*/}
                {/*                    )*/}
                {/*                })}*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*        : null}*/}


                {/*    {products.length < 1 && all.length < 1 ?*/}
                {/*        <SkeletonProduct show={sklMode}/>*/}
                {/*        : null}*/}

                {/*    /!*all products*!/*/}
                {/*    <div className="product-wrapper" style={{paddingBottom: 0}}>*/}
                {/*        {all.length > 0 && all.map(item => {*/}
                {/*            return (*/}
                {/*                <div>*/}
                {/*                    {item.products.length > 0 ? <div className="cat-title">*/}
                {/*                        <h3>{item.name}</h3>*/}
                {/*                    </div> : null}*/}
                {/*                    <div*/}
                {/*                        className={isEven(item.products.length) ? "product-list" : "product-list product-list-odd"}>*/}
                {/*                        {item.products.map(p => {*/}
                {/*                            return (*/}
                {/*                                <div className="menu-product-card" onClick={()=>{*/}
                {/*                                    productClick(p)*/}
                {/*                                }}>*/}
                {/*                                    /!*<div className="menu-product-card-img" style={{backgroundImage: `url(${p.image})`}}>*!/*/}
                {/*                                    /!*</div>*!/*/}
                {/*                                    <LazyBackground src={p.image}/>*/}
                {/*                                    <span className="title">{p.name}</span>*/}
                {/*                                    <span className="price">{`${p.price} ریال `}</span>*/}
                {/*                                </div>*/}
                {/*                            )*/}
                {/*                        })}*/}
                {/*                    </div>*/}
                {/*                </div>*/}
                {/*            )*/}
                {/*        })}*/}
                {/*    </div>*/}

                {/*</div>*/}

                {!isLogin?<div className="online-store-sec land-btn" onClick={()=>{history.push("/login",{mall:merchant.mall})}}>
                    <div className="online-store-btn">
                        <span> ورود/عضویت  در باشگاه مشتریان </span>
                    </div>
                </div>:<div className="online-store-sec land-btn" onClick={async ()=>{
                    let malli = merchant.mall;
                    await CheckinData("mc_"+malli.uid)
                    localStorage.setItem('mallId',malli.uid);
                    localStorage.setItem('mallLogo',malli.header_image);
                    localStorage.setItem('mallWhite',malli.logo);
                    localStorage.setItem('mallName',malli.name);
                    localStorage.setItem('mall',JSON.stringify(malli));
                    setMall(malli);
                    history.push("/")
                }}>
                    <div className="online-store-btn">
                        <span> ورود به صفحه اصلی </span>
                    </div>
                </div>}
            </div>
        </div>
    )
}

export {Land};
